import { pushEvent } from '../../../client/data-layer';

// Tracks when the user changes a filter for the offerlist
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  checked: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, checked });
};

export const trackProductCompareTopTenLinkClick = (productId: number) =>
  pushEvent('productCompareTopTenLinkClicked', { productId });

type ProductSizeVariantClickoutData = {
  isVariantFiltered: boolean;
  isPrimaryList: boolean;
};

export const trackProductSizeVariantClickout = (
  data: ProductSizeVariantClickoutData
) => {
  pushEvent('productSizeVariantClickout', data);
};
